export default "__VITE_ASSET__CMbxjgA9__"